<template>
  <div ref="images" @paste="onPaste" @drop="onPaste">
    <h2>ID: #{{ id }}</h2>
    <button
      @click="$refs.uploadImage.click()"
      class="btn btn-sm btn-success mb-4"
    >
      <span class="ti-plus"></span> Выбрать новые
    </button>
    <input
      type="file"
      ref="uploadImage"
      @change="chooseImages"
      accept="image/x-png,image/jpeg,image/jpg"
      :value="file_value"
      class="choose-file"
      v-bind:multiple="true"
    />

    <div
      v-if="base64.length > 0"
      :class="`upload ${uploading === true ? 'loading' : ''}`"
    >
      <draggable :tag="'ul'" v-model="base64" class="pimages mb-3">
        <li
          v-for="(b, k) in base64"
          :key="k"
          :class="b.accept === false ? 'noload' : ''"
        >
          <img :src="b.image" alt="" />
          <button @click="removeItemBase64(b)">
            <span class="ti-close"></span>
          </button>
        </li>
      </draggable>

      <button
        :disabled="base64.length === 0"
        @click="upload"
        class="btn btn-sm btn-success mr-3"
      >
        <span class="ti-save"></span> Загрузить
      </button>
      <button
        v-if="uploading === false"
        @click="uploadCancel"
        class="btn btn-sm btn-warning"
      >
        Отмена
      </button>
    </div>

    <draggable
      v-else
      :tag="'ul'"
      v-model="items"
      class="pimages"
      @change="positionItem"
    >
      <li v-for="item in items" :key="item.id">
        <img :src="item.image" alt="" />
        <button @click="removeItem(item)">
          <span class="ti-close"></span>
        </button>
      </li>
    </draggable>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";
import draggable from "vuedraggable";

export default {
  data: () => ({
    cardLink: "admin/news/card/images",
    cardUpload: "admin/news/card/images/upload",
    cardRemove: "admin/news/card/images/delete",
    cardPosition: "admin/news/card/images/position",
    items: [],
    base64: [],
    file_value: "",
    uploading: false,
  }),
  components: {
    draggable,
  },
  props: ["id"],
  async created() {
    this.items = await this.cardContent(this.cardLink, this.id, "list");
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    modalClose() {},
    modalOpen() {},
    onPaste(evt) {
      let new_images = evt.clipboardData.files;

      for (let i = 0; i < new_images.length; i++) {
        let accept = true;
        if (new_images[i].size > 51000000) accept = false;
        let size = new_images[i].size;
        const reader = new FileReader();
        reader.readAsDataURL(new_images[i]);
        reader.addEventListener("load", () => {
          try {
            let MAX_WIDTH = 600;
            let img = document.createElement("img");
            img.src = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
              let newHeight = height;
              let newWidth = width;
              let ctx = canvas.getContext("2d");
              if (width > MAX_WIDTH) {
                newHeight = (MAX_WIDTH * height) / width;
                newWidth = MAX_WIDTH;
              }
              canvas.height = newHeight;
              canvas.width = newWidth;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);
              let image = {
                key: i,
                image: canvas.toDataURL("image/jpeg"),
                accept: accept,
                size: size,
              };
              this.base64.push(image);
            };
          } catch (e) {
            let image = {
              key: i,
              image: reader.result,
              accept: accept,
              size: size,
            };
            this.base64.push(image);
          }
        });
        if (i > 9) {
          break;
        }
      }
    },
    chooseImages() {
      let new_images = this.$refs.uploadImage.files;

      for (let i = 0; i < new_images.length; i++) {
        let accept = true;
        if (new_images[i].size > 51000000) accept = false;
        let size = new_images[i].size;
        const reader = new FileReader();
        reader.readAsDataURL(new_images[i]);
        reader.addEventListener("load", () => {
          try {
            let MAX_WIDTH = 1920;
            let img = document.createElement("img");
            img.src = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
              let newHeight = height;
              let newWidth = width;
              let ctx = canvas.getContext("2d");
              if (width > MAX_WIDTH) {
                newHeight = (MAX_WIDTH * height) / width;
                newWidth = MAX_WIDTH;
              }
              canvas.height = newHeight;
              canvas.width = newWidth;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);
              let image = {
                key: i,
                image: canvas.toDataURL("image/jpeg"),
                accept: accept,
                size: size,
              };
              this.base64.push(image);
            };
          } catch (e) {
            let image = {
              key: i,
              image: reader.result,
              accept: accept,
              size: size,
            };
            this.base64.push(image);
          }
        });
        if (i > 9) {
          break;
        }
      }
      if (this.base64.length) this.file_value = "";
    },
    uploadCancel() {
      this.$modal.hide("upload");
      this.uploading = false;
      this.base64 = [];
    },
    upload() {
      this.uploading = true;
      this.base64 = this.base64.reverse();
     
      setTimeout(() => {
        if (this.base64 && this.base64[0] && this.base64[0].image) {
          this.cardUpdate(
            `${this.cardUpload}?id=${this.id}`,
            {
              image: this.base64[0].image,
            },
            "post"
          )
            .then((data) => {
              if (data && data.id) {
                this.items.unshift(data);
              }
            })
            .finally(() => {
              this.base64.splice(0, 1);
              setTimeout(() => {
                this.upload();
              }, 1500);
            });
        } else {
          this.uploading = false;
        }
      }, 10);
    },
    removeItem(item) {
      if (
        this.cardUpdate(
          `${this.cardRemove}?id=${this.id}`,
          { item: item },
          "delete"
        )
      ) {
        {
          for (let i = 0; i < this.items.length; i++) {
            if (item.id === this.items[i].id) {
              this.items.splice(i, 1);
              break;
            }
          }
        }
      }
    },
    removeItemBase64(item) {
      for (let i = 0; i < this.base64.length; i++) {
        if (item.image === this.base64[i].image) {
          this.base64.splice(i, 1);
          break;
        }
      }
    },
    positionItem() {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].position = i;
      }
      setTimeout(() => {
        this.cardUpdate(
          `${this.cardPosition}?id=${this.id}`,
          { items: this.items },
          "put"
        );
      }, 100);
    },
  },
  computed: {
    countNewImages: {
      get() {
        return this.base64.length;
      },
    },
  },
  watch: {
    countNewImages(val) {
      if (val > 0) {
        this.$modal.show("upload");
      } else {
        this.uploading = false;
        this.$modal.hide("upload");
      }
    },
  },
};
</script>
<style lang="scss">
.choose-file {
  position: absolute;
  opacity: 0;
}

ul.pimages {
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  & > li {
    background: rgba($color: #ffffff, $alpha: 0.9);
    max-width: 50%;
    width: 140px;
    height: 140px;
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ebebeb;
    position: relative;
    margin-bottom: 10px;
    border-radius: 10px;
    overflow: hidden;
    text-align: center;
    &.noload {
      border-color: red;
      border-width: 3px;
    }
    & > img {
      width: 100%;
      height: 100%;
      position: absolute;
      max-width: 75%;
      max-height: 75%;
      -o-object-fit: contain;
      object-fit: contain;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    & > button {
      border: none;
      box-shadow: none;
      position: absolute;
      right: 5px;
      top: 5px;
      background: #ebebeb;
      height: 20px;
      width: 20px;
      font-size: 10px;
      text-align: center;
      padding: 3px;
      border-radius: 3px;
    }
  }
}

.loading {
  opacity: 0.3;
  pointer-events: none;
  cursor: progress;
}
</style>
